import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { DEFAULT_SORT_ORDER } from "@/modules/contractor-panel/visits/constants";

interface SortOrderFilterProps {
  value?: "asc" | "desc";
  onChange: (value: "asc" | "desc") => void;
}

export const SortOrderFilter = ({ value, onChange }: SortOrderFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="sort-order">
        {t("contractorVisits.filter.sort.order.label")}
      </Label>
      <Select value={value || DEFAULT_SORT_ORDER} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="z-[60]">
          <SelectItem value="desc">
            {t("contractorVisits.filter.sort.order.desc")}
          </SelectItem>
          <SelectItem value="asc">
            {t("contractorVisits.filter.sort.order.asc")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
